import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  makeStyles,
  Grid,
} from "@material-ui/core";
import Controls from "./controls/Controls";
import { useState } from "react";
import { useEffect } from "react";
import { getAllBanks, getAllPaymentMethods } from "../../../services";
import { Form, useForm } from "./useForm";
import axios from "axios";
import * as sweetalert from "sweetalert";
import packageJson from "../../../../package.json";
import { getEPaymentConfig } from "../../../services/EPaymentConfig";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
const useStyles = makeStyles((theme) => ({
  dialog: {
    padding: theme.spacing(4),
    position: "absolute",
    top: theme.spacing(5),
  },
  dialogTitle: {
    textAlign: "center",
  },
  dialogContent: {
    textAlign: "center",
  },
  dialogAction: {
    justifyContent: "center",
  },
  titleIcon: {
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.secondary.main,
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      cursor: "default",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "8rem",
    },
  },
}));

export default function ConfirmDialog(props) {
  const { confirmDialog, setConfirmDialog,setBanks,setPaymentMethod,paymentMethod,Banks, setGetPaymentconfigration,Paymentconfigration } = props;
  const [fundoption, setFundoption] = useState([]);
  const [image, setImage] = useState("");
  const classes = useStyles();
  const staff_type = localStorage.getItem("staff_type");
  const [loadingFatora, setLoadingFatora] = useState(false);
  const [discount_fatora_bank, setDiscount_fatora_bank] = useState([]);
  const [increase_sell_percent, setIncrease_sell_percent] = useState([]);
  // useEffect(() => {}, [props.id]);
  useEffect(() => {
    if (loadingFatora === true && !validate()) {
      setTimeout(() => {
        // After the timeout, reset the loading state
        setLoadingFatora(false);
        // Your other logic here
      }, 2000); // Adjust the timeout duration as needed
    }
  }, [loadingFatora]);
  // useEffect(() => {
  //   getAllPaymentMethods().then((res) => {
  //     setPaymentMethod(res.data);
  //   });
  //   getAllBanks().then((res) => {
  //     setBanks(res);
  //   });
  //   getEPaymentConfig().then((res) => {
  //     setGetPaymentconfigration(res);

  //     // setIsLoading(true);
  //   });
  //   return () => {};
  // }, []);
  const initialFValues = {
    trans_id: props.id,
    amount: "",
    payment_method: "",
    bank: "",
    number_transfer: "",
    image: "",
    mobile: "",
    national_id: "",
    name: "",
   
  };

  const validate = (fieldValues = loginInput) => {
    let temp = { ...errors };
    if ("payment_method" in fieldValues) {
      if (fieldValues.payment_method == "") {
        temp.payment_method = "هذا الحقل مطلوب";
      } else {
        temp.payment_method = "";
      }
    }
    if (fundoption === "BankTransfer") {
      if ("bank" in fieldValues) {
        if (fieldValues.bank == "") {
          temp.bank = "هذا الحقل مطلوب";
        } else {
          temp.bank = "";
        }
      }
      if ("number_transfer" in fieldValues) {
        if (fieldValues.number_transfer == "") {
          temp.number_transfer = "هذا الحقل مطلوب";
        } else {
          temp.number_transfer = "";
        }
      }
      if ("image" in fieldValues) {
        if (fieldValues.image == "") {
          temp.image = "هذا الحقل مطلوب";
        } else {
          temp.image = "";
        }
      }
    } else {
      if ("bank" in fieldValues) {
        if (fieldValues.bank == "") {
          temp.bank = "";
        } else {
          temp.bank = "";
        }
      }
      if ("number_transfer" in fieldValues) {
        if (fieldValues.number_transfer == "") {
          temp.number_transfer = "";
        } else {
          temp.number_transfer = "";
        }
      }
      if ("image" in fieldValues) {
        if (fieldValues.image == "") {
          temp.image = "";
        } else {
          temp.image = "";
        }
      }
    }
 
    // if ("amount" in fieldValues)
    //   temp.amount = fieldValues.amount ? "" : " الكمية مطلوبة";
    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };

  const { loginInput, setLogin, errors, setErrors, handleInputChange } =
    useForm(initialFValues, true.validate);
  const handlefile = (e) => {
    setImage(e.target.files[0]);
    setLogin({ ...loginInput, [e.target.name]: e.target.files[0] });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {

      if (fundoption === "BankTransfer") {
        const bodyFormData = new FormData();
        bodyFormData.append("trans_id", props.id);
        bodyFormData.append("payment_method", fundoption);
        bodyFormData.append("bank", loginInput.bank);
        bodyFormData.append("number_transfer", loginInput.number_transfer);
        bodyFormData.append("image", image);
        axios
          .post(`${BaseUrl}/api/transferToPaid`, bodyFormData, {
            withCredentials: true,
          })
          .then((res) => {
            if (res.data.status == true) {
              sweetalert(res.data.msg, {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              }).then(() => {
                window.location.reload();
              });
            } else {
              sweetalert(loginInput.error_list);
              setLogin({ ...loginInput, error_list: res.data.message });
            }
          });
      } else if (fundoption === "E_payment") {
        setLoadingFatora(true);
        const bodyFormData = new FormData();
        bodyFormData.append("trans_id", props.id);
        bodyFormData.append("payment_method", fundoption);
        axios.post(`${BaseUrl}/api/transferToPaidEPayment`, bodyFormData, {
            withCredentials: true,
          })
          .then((res) => {
            if (res.data.status === true) {
              setLoadingFatora(false);
              const url = res.data.data.url;
              sweetalert("سيتم توجيهك الى نافذة الدفع الالكتروني", {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              }).then((res) => {
                window.open(url, "_blank");
                window.location.reload();
              });
            } else {
              setLoadingFatora(false);
              sweetalert(res.data.msg, {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              });
            }
          }).catch((err) => {
            if (err.response && err.response.status === 500) {
              sweetalert(err.response.msg, {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              });
            }
          });
      } else {
        const bodyFormData = new FormData();
        bodyFormData.append("trans_id", props.id);
        bodyFormData.append("payment_method", fundoption);
        axios
          .post(`${BaseUrl}/api/transferToPaid`, bodyFormData, {
            withCredentials: true,
          })
          .then((res) => {
            if (res.data.status == true) {
              sweetalert(res.data.msg, {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              }).then(() => {
                window.location.reload();
              });
            } else {
              sweetalert(loginInput.error_list);
              setLogin({ ...loginInput, error_list: res.data.message });
            }
          });
      }
    }
  };
  useEffect(() => {}, [discount_fatora_bank, increase_sell_percent]);
  const handleChange = (e, fieldName) => {
    const value = parseFloat(e.target.value);
    if (!isNaN(value)) {
      if (fieldName === "amount") {
        const discount =
          value - Paymentconfigration.discount_fatora_bank * value;
        const sell = value + Paymentconfigration.increase_sell_percent * value;
        setDiscount_fatora_bank(discount);
        setIncrease_sell_percent(sell);
        setLogin({ ...loginInput, amount: value });
      }
    } else {
      console.error("Invalid number entered");
    }
  };
  const handleInputChange1 = (e) => {
    setFundoption(e.target.value);
    setLogin({ ...loginInput, payment_method: e.target.value });
  };
  return (
    <Dialog open={confirmDialog.isOpen} classes={{ paper: classes.dialog }}>
      <DialogContent className={classes.dialogContent}>
        <Typography variant="h6">{confirmDialog.title}</Typography>
        <Typography variant="subtitle2">{confirmDialog.subTitle}</Typography>
      </DialogContent>
      <DialogActions
        className={classes.dialogAction}
        style={{ display: "flex", flexDirection: "column" }}
      >
        <Form className="form-group new-design" onSubmit={handleSubmit}>
          <Grid item style={{ width: "95%" }}>
            <label>طريقة الدفع</label>
            <div class="select">
              <select
                className="form-control"
                class="select-text"
                name="payment_method"
                onChange={handleInputChange1}
              >
                <option selected disabled>
                  اختر طريقة الدفع
                </option>
                {staff_type !== "Admin" ? (
                  <>
                    <option value="Cache">كاش</option>
                    <option value="BankTransfer">تحويل بنكي</option>
                  </>
                ) : (
                  <>
                    <option value="BankTransfer">تحويل بنكي</option>
                    <option value="Cache">كاش</option>
                  </>
                )}
              </select>
              <span class="select-highlight"></span>
              <span class="select-bar"></span>
              {loginInput.payment_method === "" ? (
                <div
                  style={{ color: "red", fontSize: "10px", textAlign: "end" }}
                >
                  {errors.payment_method}
                </div>
              ) : (
                <></>
              )}
            </div>
          </Grid>
          <Grid item lg={12} md={12} xs={12}>
            {fundoption === "BankTransfer" ? (
              <>
                <Grid item style={{ width: "95%" }}>
                  <label>البنك</label>
                  <div class="select">
                    <select
                      className="form-control"
                      class="select-text"
                      name="bank"
                      onChange={handleInputChange}
                    >
                      <option selected disabled>
                        اختر البنك
                      </option>
                      {Banks.map((opts, i) => (
                        <option key={opts.id} value={opts}>
                          {opts}
                        </option>
                      ))}
                    </select>
                    <span class="select-highlight"></span>
                    <span class="select-bar"></span>
                    <div style={{ color: "red", fontSize: "10px" }}>
                      {fundoption === "BankTransfer" ? errors.bank : ""}
                    </div>
                  </div>
                </Grid>
                <Grid item md={12} xs={12}>
                  <Controls.Input
                    label="رقم الحوالة"
                    name="number_transfer"
                    variant="outlined"
                    fullWidth
                    onChange={handleInputChange}
                    className="form-control"
                    type="number"
                    error={
                      fundoption === "BankTransfer"
                        ? errors.number_transfer
                        : ""
                    }
                  />
                </Grid>
                <Grid item md={12} xs={12}>
                  <Controls.Input
                    label="صورة الحوالة"
                    name="image"
                    variant="outlined"
                    fullWidth
                    onChange={handlefile}
                    className="form-control"
                    type="file"
                    error={fundoption === "BankTransfer" ? errors.image : ""}
                  />
                </Grid>
              </>
            ) : (
              <></>
            )}
       
          </Grid>
          <Grid item lg={12} md={12} xs={12} style={{ marginTop: "15px" }}>
            <Controls.Button
              text="تراجع"
              color="default"
              onClick={() =>
                setConfirmDialog({ ...confirmDialog, isOpen: false })
              }
            />
                 {loadingFatora === true ? (
                  <Controls.Button
                      type="submit"
                      text=<div class="spinner center">
                        <div class="spinner-blade"></div>
                        <div class="spinner-blade"></div>
                        <div class="spinner-blade"></div>
                        <div class="spinner-blade"></div>
                        <div class="spinner-blade"></div>
                        <div class="spinner-blade"></div>
                        <div class="spinner-blade"></div>
                        <div class="spinner-blade"></div>
                        <div class="spinner-blade"></div>
                        <div class="spinner-blade"></div>
                        <div class="spinner-blade"></div>
                        <div class="spinner-blade"></div>
                      </div>
                      variant="contained"
                      className="btn-submit loader-submit "
                    ></Controls.Button>
                  ) : (
                    <>

            <Controls.Button
              text="تحويل"
              color="secondary"
              onClick={handleSubmit}
            />
               
                    </>

                  )}
          </Grid>
        </Form>
      </DialogActions>
    </Dialog>
  );
}
